export class AiProcessStepBlobsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getInput(stepExecutionId) {
    return this.#http.get(`/ai-process-step-executions/${stepExecutionId}/blobs/input`);
  }

  async getOutput(stepExecutionId) {
    return this.#http.get(`/ai-process-step-executions/${stepExecutionId}/blobs/output`);
  }

  async getError(stepExecutionId) {
    return this.#http.get(`/ai-process-step-executions/${stepExecutionId}/blobs/error`);
  }

  async getSystemPrompt(stepExecutionId) {
    return this.#http.get(`/ai-process-step-executions/${stepExecutionId}/blobs/system-prompt`);
  }
}
